// src/components/Fields/SingleSelectFieldPreview.jsx
import React from 'react';
import { Typography, Box } from '@mui/material';
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle'; // Single Select Dropdown Icon
import DraggablePreviewWrapper from './DraggablePreviewWrapper';  // Ensure the path is correct
import { useFormLayout } from '../../contexts/FormLayoutContext'; // Adjust path as necessary

const SingleSelectFieldPreview = ({ id, index }) => {
    const { showDropZones, setShowDropZones } = useFormLayout();  // Use context to manage showDropZones

    // Check if the function is callable (this is more for verification and should not be used in production)
    try {
        setShowDropZones && setShowDropZones.toString(); // This will log the function's definition if it's a function
//        console.log(`[SingleSelectFieldPreview] setShowDropZones function definition:`, setShowDropZones.toString());
    } catch (error) {
        console.error("[SingleSelectFieldPreview] Error logging setShowDropZones function definition:", error);
    }

    return (
        <DraggablePreviewWrapper
            id={id}
            type="single-select" // Update the type to "single-select" to match other definitions
            index={index}
            isNew={true}
            showDropZones={showDropZones} // Pass down showDropZones state
            setShowDropZones={setShowDropZones} // Pass down setShowDropZones function
        >
            <Box display="flex" alignItems="center">
                <ArrowDropDownCircleIcon sx={{ fontSize: '0.95rem', marginRight: '8px', color: '#455A64' }} />
                <Typography variant="body2" sx={{ flexGrow: 1, fontSize: '0.85rem', color: '#455A64' }}>
                    Single-Select 
                </Typography>
            </Box>
        </DraggablePreviewWrapper>
    );
};

export default SingleSelectFieldPreview;
